import React from 'react';

const Input = React.memo(
  React.forwardRef(
    (
      {
        type,
        placeholder,
        value,
        onChange,
        label,
        block,
        className,
        error,
        disabled,
        area = false,
        rows = 3,
        rightIcon,
        leftIcon,
        Inputclass,
        onKeyDown,
      },
      ref
    ) => {
      return (
        <div className="">
          {label && <label>{label}</label>}
          {area ? (
            <textarea
              ref={ref}
              disabled={disabled}
              className={className}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              onKeyDown={onKeyDown}
              rows={rows}
            />
          ) : (
            <div className={`relative ${Inputclass}`}>
              {leftIcon}
              <input
                ref={ref}
                disabled={disabled}
                className={className}
                type={type}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
              />
              {rightIcon}
            </div>
          )}

          {error && <span className="text-red-400 max-w-[200px]">{error}</span>}
        </div>
      );
    }
  )
);

Input.displayName = 'Input';

export default Input;
